import { render, staticRenderFns } from "./ConfigAlertMsPowerAutomate.vue?vue&type=template&id=6e0690da&scoped=true"
import script from "./ConfigAlertMsPowerAutomate.vue?vue&type=script&lang=js"
export * from "./ConfigAlertMsPowerAutomate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0690da",
  null
  
)

export default component.exports